<template>
  <b-container
    id="admin-container"
    class="d-flex px-0 just-content-center align-items-center"
    fluid
  >
    <!-- TODO: find a better way to structure this -->
    <template v-if="$route.path === '/login'">
      <AdminLogin />
    </template>
    <template v-else-if="$route.path === '/forgot-password'">
      <AdminForgotPassword />
    </template>
    <template v-else-if="$route.path === '/reset-password'">
      <AdminResetPassword />
    </template>
    <template v-else-if="$route.path === '/signup'">
      <AdminSignUp />
    </template>
    <template v-else-if="$route.path === '/verify'">
      <Verify />
    </template>
    <template v-else-if="$route.path === '/resend-code'">
      <ResendCode />
    </template>
    <template v-else-if="$route.path === '/who-are-you'">
      <WhoAreYou />
    </template>
    <template v-else-if="$route.path === '/payment'">
      <Payment />
    </template>
    <template v-else-if="$route.path === '/payment/confirmed'">
      <PaymentSuccess />
    </template>
    <template v-else-if="$route.path === '/payment/failure'">
      <PaymentFailure/>
    </template>
    <template v-else-if="$route.path === '/unsubscribe'">
      <Unsubscribe/>
    </template>
    <template v-else-if="$route.path === '/survey'">
      <Survey/>
    </template>
    <template v-else-if="$route.path === '/biometrics'">
      <Biometrics/>
    </template>
    <template v-else>
      <div id="main-container" class="h-100 w-100 d-flex">
        <SidebarContainer id="sidebar"/>
        <div id="main-content-container" :class="!displayMobileNav ? 'no-margin' : ''">
          <TopBar class="px-2"/>
          <MainContent class="px-2"/>
        </div>
      </div>
    </template>
  </b-container>
</template>

<script>
import TopBar from './Layout/TopBar'
import SidebarContainer from './Layout/Sidebar/SidebarContainer'
import MainContent from './Layout/MainContent'
import AdminLogin from '../Pages/AdminAuth/AdminLogin'
import AdminForgotPassword from '../Pages/AdminAuth/AdminForgotPassword'
import AdminResetPassword from '../Pages/AdminAuth/AdminResetPassword'
import AdminSignUp from '../Pages/AdminAuth/AdminSignUp'
import Verify from '../Pages/AdminAuth/Verify'
import ResendCode from '../Pages/AdminAuth/ResendCode'
import WhoAreYou from '../Pages/AdminAuth/WhoAreYou'
import Payment from '../Pages/AdminAuth/Payment'
import PaymentSuccess from '../Pages/AdminAuth/PaymentSuccess'
import PaymentFailure from '../Pages/AdminAuth/PaymentFailure'
import Unsubscribe from '../Pages/AdminAuth/Unsubscribe'
import Vue from 'vue'
import Vuelidate from 'vuelidate'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import { mapGetters, mapActions } from 'vuex'
import Survey from '../Pages/AdminAuth/Survey'
import Biometrics from '../Pages/AdminAuth/Biometrics'

import './bootstrap_overwrite.scss'

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(Vuelidate)

export default {
  name: 'Admin',
  components: {
    TopBar,
    SidebarContainer,
    MainContent,
    AdminLogin,
    AdminForgotPassword,
    AdminResetPassword,
    AdminSignUp,
    Verify,
    ResendCode,
    WhoAreYou,
    Payment,
    PaymentSuccess,
    PaymentFailure,
    Unsubscribe,
    Survey,
    Biometrics
  },
  data() {
    return {
      title: 'Admin'
    }
  },
  computed: {
    ...mapGetters(['displayMobileNav', 'toast']),
    isMobile() { return window.innerWidth < 768 }
  },
  methods: {
    ...mapActions(['dispatchToast']),
    showToast() {
      this.$bvToast.toast(this.toast.message, {
        title: this.toast.title,
        solid: true,
        toaster: 'b-toaster-bottom-right'
      })
    }
  },
  watch: {
    toast() {
      this.showToast()
    }
  }
}
</script>

<style scoped>
#admin-container {
  margin-top: 50px;
  min-height: calc(100vh - 50px);
}

#main-container {
  background-color: #f5f5f5;
}

#main-container > * {
  transition: all 300ms ease-in-out;
}

#main-content-container {
  width: calc(100% - 70px);
  max-width: 2000px;
  height: calc(100vh - 60px);
  margin-left: 70px;
  position: relative;
  overflow-y: scroll;
  overflow-x: hidden;
}

#sidebar {
  z-index: 2;
  position: fixed;
  height: calc(100vh - 50px);
}

#toast-container {
  position: fixed;
  right: 15px;
  bottom: 15px;
  z-index: 3;
  width: 300px;
  height: 90px;
  background-color: red;
}

@media (max-width: 768px) {
  .no-margin {
    margin-left: 0px !important;
    width: 100% !important;
  }
}

@media (min-width: 1200px) {
  #main-content-container {
    margin-left: 200px;
    width: calc(100% - 200px);
  }
}
</style>



// WEBPACK FOOTER //
// src/app/components/Admin.vue?5cc7a03b